import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	totalStep: 3,
	asset: null,
	account: null,
	isCardTopUp: false,
};

export const receiveSlice = createSlice({
	name: 'receive',
	initialState,
	reducers: {
		resetState: () => initialState,
		setReceiveData: (state, action) => {
			const { payload: receiveData = initialState } = action;
			if (!receiveData.asset) {
				return { ...initialState };
			} else if (!receiveData.account) {
				return { ...initialState, totalStep: 2, asset: receiveData.asset };
			} else {
				return { ...initialState, totalStep: 1, asset: receiveData.asset, account: receiveData.account };
			}
		},
		setAsset: (state, action) => {
			const { payload: asset = initialState.asset } = action;
			state.asset = asset;
		},
		setAccount: (state, action) => {
			const { payload: account = initialState.account } = action;
			state.account = account;
		},
		setIsCardTopUp: (state, action) => {
			const { payload: isCardTopUp = initialState.isCardTopUp } = action;
			state.isCardTopUp = isCardTopUp;
		},
	},
});
